import transactionHistory from '../data/transactionHistoryData/transactionHistory.json';

export const getAllTableData = (persona: any) => {
    const data: any = transactionHistory['data'];

    return data[persona];
};
